import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { BookingUrl } from '../../../shared/urls/booking.url';
import { CalendarModel } from '../../../models/booking/booking-details.model';
import * as moment from 'moment';

@Injectable()

export class ManageBookingService {
    constructor(public baseService: BaseService) {}

    getBookingList(param) {
        const url = BookingUrl.GET_BOOKINGS;
        return this.baseService.post(url, param);
    }
    changeTimeManageBooking(id, param){
        const url = BookingUrl.CHANGE_TIME_MANAGE_BOOKING + `${id}`;
        return this.baseService.put(url, param);
    }

    getChildFluVaccineBooking(id, param){
        const url = BookingUrl.GET_CHILD_FLU_VACCINE_BOOKING  + `${id}`;
        return this.baseService.put(url, param);
    }
    addBooking(param) {
        const url = BookingUrl.ADD_BOOKING;
        return this.baseService.postData(url, param);
    }
    deleteBookingCache() {
        const url = BookingUrl.DELETE_BOOKING_CACHE;
        return this.baseService.delete(url);
    }
    convertBookingDateToLocalString(date) {
        return moment.utc(date).local().format('YYYY-MM-DDTHH:mm:ss');
    }
    convertBookingDateToUTCString(date) {
        return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss');
    }
    convertBookingListToLocalTime(list) {
        list.forEach(i => {
            i = this.convertBookingItemToLocalTime(i);
        });
        return list;
    }
    convertBookingItemToLocalTime(item) {
        item['start'] = moment.utc(item['start']).local().format('YYYY-MM-DDTHH:mm:ss');
        item['end'] =  moment.utc(item['end']).local().format('YYYY-MM-DDTHH:mm:ss');
        return item;
    }
    convertBookingDisableDateToLocalTime(list) {
        list.forEach(i => {
            i = moment.utc(i).local().format('YYYY-MM-DDTHH:mm:ss');
        });
        return list;
    }
}

/* const bookingInfo = <CalendarModel>{
    bookingList : [
        {
          id: '1',
          title: 'booking ref', // booking ref or patient name
          class: 'Confirmed', // status
          start: '2018-01-06T01:00:00',
          end: '2018-01-06T02:30:24',
          readOnly: true,
          status: 1,
          bookingType: 0
      },
      {
          id: '2',
          title: 'booking ref', // booking ref
          class: 'Arrived', // status
          start: '2018-01-05T01:00:00',
          end: '2018-01-05T01:30:00',
          readOnly: false,
          status: 2,
          bookingType: 1
      },
      {
          id: '3',
          title: 'booking ref', // booking ref
          class: 'DNA', // status
          start: '2018-01-02T01:00:00',
          end: '2018-01-02T01:30:00',
          readOnly: false,
          status: 3,
          bookingType: 1
      },
      {
          id: '4',
          title: 'booking ref', // booking ref
          class: 'NewBooking', // status
          start: '2018-01-03T01:00:00',
          end: '2018-01-03T01:30:00',
          readOnly: true,
          status: 0,
          bookingType: 1
      },
      {
          id: 'f1',
          title: 'Patient 4, Patient 5, Patient 6', // booking ref
          class: 'Flu', // status
          start: '2018-01-06T01:00:00',
          end: '2018-01-06T01:05:00',
          readOnly: true,
          status: null,
          bookingType: 2
      },
      {
          id: 'f2',
          title: 'Patient 1, Patient 2, Patient 3', // booking ref
          class: 'Flu', // status
          start: '2018-01-06T01:05:00',
          end: '2018-01-06T01:10:00',
          readOnly: true,
          status: null,
          bookingType: 2
      }
    ],
    disableDates: ['2018-01-03'],
    disableTimes: [
        {
            start: "0:00",
            end: "8:00"
        },
        {
            start: "12:00",
            end: "13:00"
        },
        {
            start: "17:00",
            end: "24:00"
        }
    ]
};
 */


/* NewBooking = 0,
Confirmed = 1,
Arrived = 2,
DNA = 3,
Cancelled = 4,
Flu = 5


export enum PartyType {
	Individual = 0,
	Group = 1,
	FluVaccine = 2
}
*/


/* events: [{
    title: 'Call Dave',
    class: 'bg-success-lighter',
    start: '2017-12-21T06:00:00',
    end: '2017-12-21T08:00:24',
    status: 1,
    other: {}
}, {
    title: 'Meeting Roundup',
    class: 'bg-success-lighter',
    start: '2014-11-07T06:00:00'
}, {
    title: 'Double click Any where',
    class: 'bg-complete-lighter',
    start: moment().startOf('week').add(1, 'days').add(2, 'hours').format(),
    end: moment().startOf('week').add(1, 'days').add(6, 'hours').format(),
    other: {
        //You can have your custom list of attributes here
        note: 'test'
    }
}, {
    title: 'Drag Me',
    class: 'bg-success-lighter',
    start: moment().startOf('week').add(2, 'days').add(2, 'hours').format(),
    end: moment().startOf('week').add(2, 'days').add(3, 'hours').format(),
    other: {
        //You can have your custom list of attributes here
        note: 'test'
    }
}, {
    title: 'Click me',
    class: 'bg-danger-lighter',
    start: moment().startOf('week').add(2, 'days').add(5, 'hours').format(),
    end: moment().startOf('week').add(2, 'days').add(6, 'hours').format(),
    other: {
        //You can have your custom list of attributes here
        note: 'test'
    }
}, ], */




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/manage-booking/manage-booking.service.ts